import Turnstile, { useTurnstile } from 'react-turnstile'

const isDev = process.env.NODE_ENV === 'development'

// INFO: For testing purposes only (always pass)
// sitekey='1x00000000000000000000AA'
const siteKey = isDev
  ? '1x00000000000000000000AA'
  : (process.env.NEXT_PUBLIC_CLOUDFLARE_SITE_KEY as string)

export const TurnstileWidget = (props) => {
  const { handleVerifyToken } = props
  const turnstile = useTurnstile()

  return (
    <Turnstile
      sitekey={siteKey}
      onVerify={async (token) => {
        const isValid = await handleVerifyToken(token)
        if (!isValid) {
          turnstile.reset()
        }
      }}
    />
  )
}
